'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = require('../internal/predicates');

exports.default = _predicates.isRecord;


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/isRecord.js
// module id = 134
// module chunks = 35783957827783 107818501498521